export const SELECTOR_PAY_METHOD = (state) => state.paymentReducer.paymentMethod;
